export const FILTERING_PROPERTIES = [
    {
        propertyLabel: 'Title',
        key: 'title',
        groupValuesLabel: 'Titles',
        operators: [':', '!:', '=', '!='] as const,
    },
    {
        propertyLabel: 'Description',
        key: 'description',
        groupValuesLabel: 'Description',
        operators: [':', '!:', '=', '!='] as const,
    },
] as const;
